import axios from "axios";
import constants from "./constants";

export function defaultGet(apiName, success, failure, isCustom) {
    var fullMethodUrl = (isCustom ? constants.baseApiUrl : constants.ctsApiUrl) + apiName;

    axios.get(fullMethodUrl, { headers: constants.headers })
        .then((res) => success(res))
        .catch((err) => failure(err));
}

export function defaultPost(apiName, body, success, failure, isCustom) {
    var fullMethodUrl = (isCustom ? constants.baseApiUrl : constants.ctsApiUrl) + apiName;

    axios.post(fullMethodUrl, body, { headers: constants.headers })
        .then((res) => success(res))
        .catch((err) => failure(err));
}

export function CapitalizeFirstLetter(str) {
    if (str == null || str == undefined || str == "")
        return ""

    try {
        const words = str.trim().split(" ");
        var retVal = words[0][0] + words[words.length - 1][0];
        return retVal.toUpperCase();
    }
    catch (err) { console.log(err) }
}

export function alertMessage(message) {
    alert(message)
}

export function DownloadFile(getRequestUrl, fileName) {
    var req = new XMLHttpRequest();
    req.open("GET", getRequestUrl, true);
    req.setRequestHeader("Authorization", 'Bearer ' + sessionStorage.getItem('jwt_token'));
    req.responseType = "blob";
    req.onload = function () {
        if (this.status === 204) {
            var strURL = getRequestUrl.toString();
            if (strURL.toLowerCase().includes("with")) {
                window.showAlert("res_Msgs_ThereIsNoAttachment", "warning")
            }
            else {
                window.showAlert("res_Msgs_UnableToDownload", "warning")
            }
            return
        }

        if (this.status === 500) {
            window.showAlert("res_Msgs_UnableToDownload", "warning")
            return
        }

        //Convert the Byte Data to BLOB object.
        var blob = new Blob([req.response], { type: "application/octetstream" });
        //Check the Browser type and download the File.

        var isIE = false || !!document.documentMode;
        if (isIE) {
            window.navigator.msSaveBlob(blob, fileName);
        }
        else {
            var url = window.URL || window.webkitURL;
            var link = url.createObjectURL(blob);
            var a = document.createElement("a");
            a.setAttribute("download", fileName);
            a.setAttribute("href", link);
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }

        window.showAlert('res_Msgs_AttachmentDownloaded', 'success')
    };
    req.send();
}

export function PrintFile(getRequestUrl, fileName) {
    var req = new XMLHttpRequest();
    req.open("GET", getRequestUrl, true);
    req.setRequestHeader("Authorization", 'Bearer ' + sessionStorage.getItem('jwt_token'));
    req.responseType = "blob";
    req.onload = function () {
        if (this.status === 204) {
            var strURL = getRequestUrl.toString();
            if (strURL.includes("with")) {
                window.showAlert("There is no letter/attachment for the selected correspondence", "warning")
            }
            else {
                window.showAlert("Unable to print for the selected correspondence", "warning")
            }

            return
        }

        var blob = new Blob([req.response], { type: "application/pdf" });
        var blobURL = URL.createObjectURL(blob);

        var iframe = document.createElement('iframe'); //load content in an iframe to print later
        document.body.appendChild(iframe);

        iframe.style.display = 'none';
        iframe.src = blobURL;
        iframe.onload = function () {
            setTimeout(function () {
                iframe.focus();
                iframe.contentWindow.print();
            }, 1);
        };
    };
    req.send();
}

export function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function CheckIfNullOrEmpty(value) {
    if (value == null || value == undefined || value == {} || value == "" || value == "null")
        return true;
    else
        return false;
}

export function GetMultiSelectSubHeaderDisplay(options) {
    var retVal = '';
    if (options.isUser) {
        retVal = options.profession + ' - ' + (options.parentName ? options.parentName : '') + ' ( ' + (options.companyName ? options.companyName : '') + ' )'
    }
    else {
        if (options.parentName != null && options.companyName != null)
            {  retVal = options.parentName + ' ( ' + options.companyName + ' )'}
        else if (options.parentName != null) 
            {  retVal = options.parentName }
    } 
    return retVal;
}

export function GetDateOnly(strDateTime) {
    if (strDateTime == null || strDateTime == undefined || strDateTime == "")
        return ""

    var date = new Date(strDateTime)
    var day = date.getDate()
    var month = date.getMonth() + 1
    var year = date.getFullYear()

    // convert month to 2 digits
    if (month < 10)
        month = '0' + month

    return year + '-' + month + '-' + day
}

export function formatBytes(bytes, decimals = 2) {
    if (!+bytes) return '0 Bytes'

    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}

const overDueStatus = {
    emtpyStatus: 1,
    today: 2,
    nearDue: 3,
    overDue: 4
};

export function getOverDueByNode(overdue, nodeId) {
    var overDueByNode = overDueStatus.emtpyStatus;

    if (overdue == '' || nodeId == 1 || nodeId == 8) {
        overDueByNode = overDueStatus.emtpyStatus;
    }
    else {
        if (overdue == "today")
            overDueByNode = overDueStatus.today
        else if (overdue == "overdue")
            overDueByNode = overDueStatus.overDue
        else if (overdue == "neardue")
            overDueByNode = overDueStatus.nearDue
    }

    return overDueByNode;
}
export function getOverDue(overdue, nodeId) {
    var overDueIcon = ''
    var overDueByNode = this.getOverDueByNode(overdue, nodeId);

    switch (overDueByNode) {
        case overDueStatus.emtpyStatus: overDueIcon = ''; break;
        case overDueStatus.today: overDueIcon = 'mdi-clock'; break;
        case overDueStatus.nearDue: overDueIcon = 'mdi-clock'; break;
        case overDueStatus.overDue: overDueIcon = 'mdi-overdue'; break;
        default: overDueIcon = ''; break;
    }

    return overDueIcon;
}

export function getOverdueDays(overdue, overdueDays, nodeId) {
    var overdueResult = '';
    var overDueByNode = this.getOverDueByNode(overdue, nodeId);

    switch (overDueByNode) {
        case overDueStatus.emtpyStatus: overdueResult = ''; break;
        case overDueStatus.today: overdueResult = window.translate('res_Label_Today'); break;
        case overDueStatus.nearDue:
            overdueResult = Math.abs(parseInt(overdueDays)) == 1 ? + Math.abs(parseInt(overdueDays)) + ' ' + window.translate('res_Label_Day')
                : Math.abs(parseInt(overdueDays)) + ' ' + window.translate('res_Label_Days'); break;
        case overDueStatus.overDue: overdueResult = window.translate('res_Label_Overdue'); break;
        default: overdueResult = ''; break;
    }

    return overdueResult
}

export function getPriorityClassColor(priorityId) {
    switch (priorityId) {
        case 1: return ''; break;
        case 2: return 'text-warning'; break;
        case 3: return 'text-danger'; break;
    }

    return '';
}

export function getPriorityName(id) {
    //console.log(constants.priorities)
    var priority = constants.priorities.find(x => x.id == id);
    if (priority != null) {
        return priority.name
    }
    else {
        return ''
    }
}

export function getPrivacyName(id) {
    var privacy = constants.privacies.find(x => x.id == id)
    if (privacy != null)
        return privacy.name
    else
        return ''
}

export function getStatusClass(id) {
    var status = constants.statuses.find(x => x.id == id)
    if (status != null)
        return status.classColor.toLowerCase().replace(" ", "_")
    else
        return ''
}

export function getStatus(id) {
    var status = constants.statuses.find(x => x.id == id)
    if (status != null)
        return status.name
    else
        return ''
}

export function formatDateTime(datetime) {
    try {
        if (datetime == null || datetime == undefined || datetime == "")
            return ""
        const parts = datetime.replace('T', ' ').split(" ");
        const dateParts = parts[0].split("-");
        const year = dateParts[0].substring(2);
        const month = dateParts[1];
        const day = dateParts[2];
        const formattedDate = `${day}/${month}/${year}`;
        return formattedDate;
    }
    catch (e) {
        return datetime;
    }
}

export function formatDateTimeWithTime(datetime) {
    try 
    {
        if (datetime == null || datetime == undefined || datetime == "")
            return ""

        const [datePart, timePart] = datetime.split("T");
        const [hours, minutes] = timePart.split(":");

        const dateParts = datePart.split("-");
        const formattedDate = dateParts[2] + '/' +  dateParts[1] + '/' + dateParts[0].substring(2) + ' ' 
            + hours + ':' + minutes ;

        return formattedDate;
    }
    catch (e) {
        return datetime;
    }
}

export function dateFormat(inputDate, format, includeTime) 
{
    if (inputDate == null || inputDate == undefined || inputDate == "")
    {
        return ""
    }

    if (!format) 
        format = 'dd/MM/yyyy'
    
    if (includeTime)
        format = format + " hh:mm:ss"

    if (inputDate != null && inputDate != undefined && inputDate != '') 
    {
        const date = new Date(inputDate);

        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();

        format = format.replace("MM", month.toString().padStart(2, "0"));

        if (format.indexOf("yyyy") > -1) {
            format = format.replace("yyyy", year.toString());
        } else if (format.indexOf("yy") > -1) {
            format = format.replace("yy", year.toString().substr(2, 2));
        }

        format = format.replace("dd", day.toString().padStart(2, "0"));

        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        if (format.indexOf("hh") > -1) {
            format = format.replace("hh", hours.toString());
        }
        if (format.indexOf("mm") > -1) {
            format = format.replace("mm", minutes.toString());
        }
        if (format.indexOf("ss") > -1) {
            format = format.replace("ss", seconds.toString());
        }
        return format;
    }
}

export function formatDateFromString(date) {
    return new Date(date);
}

export const applyDrag = (arr, dragResult) => {
    const { removedIndex, addedIndex, payload } = dragResult
    if (removedIndex === null && addedIndex === null) return arr

    const result = [...arr]
    let itemToAdd = payload

    if (removedIndex !== null) {
        itemToAdd = result.splice(removedIndex, 1)[0]
    }

    if (addedIndex !== null) {
        result.splice(addedIndex, 0, itemToAdd)
    }

    return result
}

export function GetTranslatedValue(enVal, arVal) {
    var val = enVal;
    if (localStorage.getItem('lang') == 'ar' && arVal) {
        val = arVal
    }

    return val;
}

export function copyObject(sourceObject, targetObject) {
    for (const key in sourceObject) {
        targetObject[key] = sourceObject[key];
    }

    return targetObject;
}

export function ActionsPermission(actionName, document, transferId, delegationId , openedFromNodeId, canSign,userId = 0,isContainedInSignerList=null) 
{
    var isUserManager = constants.isManager;
    var userHasManager = false
    try 
    {
        //isUserManager = (JSON.parse(sessionStorage.getItem('user')).profile.Clients[0].lastIndexOf('Manager') != -1)

        var managerId = JSON.parse(sessionStorage.getItem('user')).profile.ManagerId
        userHasManager = (managerId != null && managerId != undefined && managerId != 0)
    } 
    catch (error) { }

    if (transferId > 0)
        document.isRegistered = true
    else
        document.showVisualTracking = false
    
    if (openedFromNodeId == null || openedFromNodeId == undefined)
        openedFromNodeId = 0
    
    let isWorkflowAction = this.hasActiveWorkflow(document);
    let isRegularTransfer = this.isRegularTransferThroughWorkflow(document); 
    let isCcTransfer = document.isCc; 
    let isStartWorkflowAction = document.isWorkflowStartStep == true;

    // openedFromNodeId
    // 1: draft, 2: inbox, 6: sent, 8: archive, 9: followup, 7: saved for later, 13:readonly
    var retVal = false 
    if (isWorkflowAction == false || (isRegularTransfer == true && isStartWorkflowAction == false) || isCcTransfer == true)
    {
        var userActionsToolbarMenu = constants.userActions.toolbarMenu
        var signedEnum = constants.statusesEnum.Signed

        switch (actionName) 
        {
            case 'Preview':
                retVal = eval(window.reviewCondition)
                break        
            case 'Forward':
                // retVal = //eval(window.forwardCondition)
                retVal = [0, 1, 2].indexOf(openedFromNodeId) > -1 &&
                    (openedFromNodeId == 1 ||
                        (document.isRegistered && openedFromNodeId != 6 &&
                            (document.statusId == 1 || (document.statusId != 3 && (document.cCed == false && document.secretForward != true)))

                        )) && userActionsToolbarMenu.some(x => x.name.toLowerCase() == 'forward')

break
            case 'ForwardCc':
                retVal = eval(window.forwardCcCondition)
                break
            case 'Recall':
                retVal = eval(window.recallCondition)
                break
            case 'ResetDocument':
                retVal = eval(window.editSignedCondition)
                break

            case "Approve":
                retVal = [2].indexOf(openedFromNodeId) > -1 && document.purposeId == 25 && document.statusId == 5 
                    && constants.userActions.toolbarMenu.some(x=>x.name.toLowerCase() == constants.actionsEnum.toolbarMenu.Approve.key)
                break
            case 'PublishToMultiDocument':
                if (document != null && document.receivingEntities != null) {
                    var receivingEntitiesObjects = JSON.parse(document.receivingEntities)
                    retVal = document.categoryId == 2 && constants.enableRecipientsMultiDocuments && receivingEntitiesObjects.length > 1 
                    && constants.userActions.toolbarMenu.some(x=>x.name.toLowerCase() == constants.actionsEnum.toolbarMenu.PublishToMultiDocument.key)
                    break
                }
                return false
            case 'DispatchCorrespondence':
                retVal = [0,1,2].indexOf(openedFromNodeId) > -1 && (document.isRegistered && openedFromNodeId != 6 && (document.statusId == 1 || (document.cCed == false && document.secretForward != true)))
                && constants.userActions.toolbarMenu.some(x=>x.name.toLowerCase() == constants.actionsEnum.toolbarMenu.DispatchCorrespondence.key)
                && document.categoryId == 2
                break;
            case 'VisualTracking': 
                retVal =  ([2,6,8,9].indexOf(openedFromNodeId) > -1 || transferId > 0 || document.showVisualTracking)
                && constants.userActions.toolbarMenu.some(x=>x.name.toLowerCase() == constants.actionsEnum.toolbarMenu.VisualTracking.key)
                break
            case 'SigningHistory':
                retVal =  document.categoryId != 1 && document.statusId != 1
                && constants.userActions.toolbarMenu.some(x=>x.name.toLowerCase() == constants.actionsEnum.toolbarMenu.SigningHistory.key)
                break
            case 'Endorse':
                if ((window.enableManagerProperty && isUserManager == true) || userHasManager == false)
                    retVal = false
                else
                {
                    retVal = [0,1,2].indexOf(openedFromNodeId) > -1 && (document.isRegistered && openedFromNodeId != 6 && (document.statusId == 1 || (document.cCed == false && document.secretForward != true)))
                    && constants.userActions.toolbarMenu.some(x=>x.name.toLowerCase() == constants.actionsEnum.toolbarMenu.Endorse.key)
                }
                break
            case 'Archive':
                
                retVal = [0,1,2,13].indexOf(openedFromNodeId) > -1 && (document.isRegistered && openedFromNodeId != 6 && (document.secretForward != true && (transferId != 0 || document.categoryId == 1)))
                && constants.userActions.toolbarMenu.some(x=>x.name.toLowerCase() == constants.actionsEnum.toolbarMenu.Archive.key)
                break
            case 'SendBack': 
                retVal = [2].indexOf(openedFromNodeId) > -1 && (openedFromNodeId != 6 && (document.isRegistered === true && document.cCed == false && transferId > 0))
                && constants.userActions.toolbarMenu.some(x=>x.name.toLowerCase() == constants.actionsEnum.toolbarMenu.SendBack.key)
                break
            case 'Reject':
                retVal =  [2].indexOf(openedFromNodeId) > -1 && (transferId > 0 && (checkCanSignDocument(document, delegationId, canSign,'reject') || document.purposeId == 15) && document.secretForward != true)
                && constants.userActions.toolbarMenu.some(x=>x.name.toLowerCase() == constants.actionsEnum.toolbarMenu.Reject.key)
                break
            case 'DeleteDraft':
                retVal = [0,1].indexOf(openedFromNodeId) > -1 && document.statusId == 1
                && constants.userActions.toolbarMenu.some(x=>x.name.toLowerCase() == constants.actionsEnum.toolbarMenu.DeleteDraft.key)
                break
            case 'NotifyEmail': case 'CancelFollowup':
                retVal = [9].indexOf(openedFromNodeId) > -1 && (constants.userActions.toolbarMenu.some(x=>x.name.toLowerCase() == constants.actionsEnum.toolbarMenu.NotifyEmail.key) 
                || constants.userActions.toolbarMenu.some(x=>x.name.toLowerCase() == constants.actionsEnum.toolbarMenu.CancelFollowup.key))
                break
            case 'Sign':
                retVal = [0,1,2].indexOf(openedFromNodeId) > -1 && ( checkCanSignDocument(document, delegationId, canSign,'sign',isContainedInSignerList) && document.secretForward != true) && constants.client_version_Id != 'ADFD' 
                break
            case 'SignAndSend':
                retVal = [0,1,2].indexOf(openedFromNodeId) > -1 && ( checkCanSignDocument(document, delegationId, canSign,'signandsend',isContainedInSignerList) && document.secretForward != true)
                break
            case 'Dismiss':
                retVal = ([2].indexOf(openedFromNodeId) > -1 ||([0].indexOf(openedFromNodeId) > -1 && document.statusId!=1) )&& constants.userActions.toolbarMenu.some(x=>x.name.toLowerCase() == constants.actionsEnum.toolbarMenu.Dismiss.key)
                break
            case 'CreateOutgoing':
                retVal = [2, 6, 8, 9].indexOf(openedFromNodeId) > -1 && (document.categoryId == 1) && constants.userActions.toolbarMenu.some(x=>x.name.toLowerCase() == constants.actionsEnum.toolbarMenu.CreateOutgoing.key)
                break
            case 'ForceGenerateReferenceNumber':
                retVal = [0,1].indexOf(openedFromNodeId) > -1 && document.isRegistered && document.categoryId != 1 && constants.userActions.toolbarMenu.some(x => x.name.toLowerCase() == constants.actionsEnum.toolbarMenu.ForceGenerateReferenceNumber.key)
                break
            case 'GenerateDeliveryNote':
                retVal = [2].indexOf(openedFromNodeId) > -1 && constants.userActions.toolbarMenu.some(x=>x.name.toLowerCase() == constants.actionsEnum.toolbarMenu.GenerateDeliveryNote.key)
                break
            case 'HideCorrespondence':
                retVal = [2].indexOf(openedFromNodeId) > -1 && constants.userActions.toolbarMenu.some(x=>x.name.toLowerCase() == constants.actionsEnum.toolbarMenu.HideCorrespondence.key)
                break
            case 'EmailReminder':
                retVal = [2].indexOf(openedFromNodeId) > -1 && constants.userActions.toolbarMenu.some(x=>x.name.toLowerCase() == constants.actionsEnum.toolbarMenu.EmailReminder.key)
                break
            case 'ReturnToInbox':
                retVal = [7].indexOf(openedFromNodeId) > -1
                break
            case 'DismissCced':
                retVal = [10].indexOf(openedFromNodeId) > -1 
                break
            case 'Replace':
                retVal = [2].indexOf(openedFromNodeId) > -1 && constants.userActions.toolbarMenu.some(x=>x.name.toLowerCase() == constants.actionsEnum.toolbarMenu.Replace.key)
            break
            case 'ReplaceOriginalMail':
                
                retVal = [0,1,2].indexOf(openedFromNodeId) > -1 && constants.userActions.toolbarMenu.some(x=>x.name.toLowerCase() == constants.actionsEnum.toolbarMenu.ReplaceOriginalMail.key)
                //console.log("heeere")
                //console.log(constants.userActions)
                //console.log(retVal)
                break
            case 'SendCC':
                retVal = ([6,2].indexOf(openedFromNodeId) > -1 ||([0].indexOf(openedFromNodeId) > -1 && document.statusId!=1) ) && document.secretForward != true
                && constants.userActions.toolbarMenu.some(x=>x.name.toLowerCase() == constants.actionsEnum.toolbarMenu.SendCC.key)
                break
            case 'TaskReminder':
                    retVal = [2].indexOf(openedFromNodeId) > -1 && constants.userActions.toolbarMenu.some(x=>x.name.toLowerCase() == constants.actionsEnum.toolbarMenu.TaskReminder.key)
                    break    
            case 'OpenWorkflowTransferForm':
                return true;
                break 
        }
    }
    else
    {
        if (openedFromNodeId != 0 && openedFromNodeId != 1 && openedFromNodeId != 2)
            retVal =  false;
        else
        {
            // workflow actions  
            let isFinalWorkflowAction = this.IsFinalWorkflowStep(document);  
            let hasRejectStep = this.hasRejectStep(document)
            let hasVote = document.hasVote;
            let canReject = document.canReject;
            let canAdvance = document.canAdvance;

            switch (actionName) 
            { 
                case 'Workflow-Complete':  
                    retVal = false && isFinalWorkflowAction;  
                break; 
                case 'Workflow-Start':  
                    retVal = !isFinalWorkflowAction && isStartWorkflowAction;  
                    break;  
                case 'Workflow-Sign':    
                    retVal = !isStartWorkflowAction && document.workflowInfo != null && this.userCanSign_WorkflowAction(this.getWorkflowInfo(document.workflowInfo));   
                    break; 
                case 'Workflow-Advance':   
                    // retVal = !isFinalWorkflowAction && !isStartWorkflowAction;   
                    retVal = !isStartWorkflowAction && canAdvance;   
                    break;
                case 'Workflow-Reject':    
                    // retVal = !isFinalWorkflowAction && !isStartWorkflowAction && hasRejectStep;  
                    retVal = !isStartWorkflowAction && canReject;  
                    break;
                case 'Workflow-Transfer':
                    retVal = !isStartWorkflowAction && document.workflowInfo != null && this.userCanTransfer_WorkflowAction(this.getWorkflowInfo(document.workflowInfo));   
                    break;
                case 'Workflow-Vote':   
                    retVal = !hasVote && !isStartWorkflowAction &&  document.workflowInfo != null && this.userCanVote_WorkflowAction(this.getWorkflowInfo(document.workflowInfo));
                    break;
                case 'Workflow-VotingResults': 
                    retVal = !isStartWorkflowAction &&  document.workflowInfo != null && this.userCanSeeVotingResults_WorkflowAction(this.getWorkflowInfo(document.workflowInfo)); 
                    break;    
            }
        }
    }

    return retVal;
}

export function checkCanSignDocument(document, delegationId, canSign,actionKey,isContainedInSignerList) {
    // 8: For Signature, 3: For Action
    var signAllowedPurposes = [8, 3, 0, null, undefined];
    var currentUserId = JSON.parse(sessionStorage.getItem('user')).profile.userId
    if (delegationId != null && delegationId != undefined && delegationId != 0) {
        var delegation = constants.delegations.find(x => x.id === delegationId)
        if (delegation != null) {
            // document.purposeId === 8 || document.purposeId === 3  || document.purposeId === 0 || document.purposeId == null 
            return delegation.canSign === true && canSign === true &&  IsCced(document) == false &&
                (
                    (signAllowedPurposes.indexOf(document.purposeId) > -1) ||
                    (document.purposeId === 19 && signAllowedPurposes.indexOf(document.purposeIdBeforeRevoke) > -1)
                )
        }
    }
    else {
        if(constants.enableConfigrationSignature== true)
            { 
                 return canSign === true &&(isContainedInSignerList || isContainedInSignerList == null )&& IsCced(document) == false && constants.userActions.toolbarMenu.some(x=>x.name.toLowerCase() == actionKey) &&
                        (
                            (signAllowedPurposes.indexOf(document.purposeId) > -1) ||
                            (document.purposeId === 19 && signAllowedPurposes.indexOf(document.purposeIdBeforeRevoke) > -1)
                        )
        

            }
        else{
            return canSign === true && IsCced(document) == false && constants.userActions.toolbarMenu.some(x=>x.name.toLowerCase() == actionKey) &&
            //&& (document.purposeId === 8 || document.purposeId === 3  || document.purposeId === 0 || document.purposeId == null || document.purposeId === 19)
                (
                    (signAllowedPurposes.indexOf(document.purposeId) > -1) ||
                    (document.purposeId === 19 && signAllowedPurposes.indexOf(document.purposeIdBeforeRevoke) > -1)
                )
            }

          
    }
}


export function IsStartWorkflow(val)
{  
   return val == null || val <= 0;
} 

export function getWorkflowInfo(obj)
{ 
    return JSON.parse(obj)[0]; 
}
  
export function userCanSeeVotingResults_WorkflowAction(obj)
{ 
   return obj.CanSeeVotingResults == true;
}

export function userCanTransfer_WorkflowAction(obj)
{ 
   return obj.CanTransfer == true; 
}

export function userCanSign_WorkflowAction(obj)
{ 
   return obj.CanSign == true; 
}
 
export function userCanVote_WorkflowAction(obj)
{ 
   return obj.CanVote == true; 
}
 
export function IsFinalWorkflowStep(obj)
{   
    return obj.finalWorkflowStep == 1;
} 


export function isRegularTransferThroughWorkflow(obj)
{ 
	return obj.transferWorkflowStepInstanceId == null && obj.workflowId > 0;
}

export function hasRejectStep(document) {   
    return document.hasRejectStep == true; 
}
 
export function hasActiveWorkflow(document) {  
    return typeof(document.workflowId) != 'undefined' && document.workflowId > 0 && document.hasActiveWorkflow == true; 
}


export function getWorkflowId(document) {  
    return (typeof(document.workflowId) != 'undefined' && document.workflowId > 0) ? document.workflowId : 0; 
}

export function IsCced(document) {
    return document.purposeId == 4 || document.cCed == true
}

export function SwitchByLang(englishResource = "", arabicResource = "", lang = "") {
    var language = 'ar';
    if (lang.trim() != "" && (lang == 'en' || lang == 'ar'))
        language = lang;
    else if (localStorage.getItem('lang') != null)
        language = localStorage.getItem('lang');

    var isEnglishResourceHasValue = false;
    var isArabicResourceHasValue = false;

    isEnglishResourceHasValue = englishResource !== "" && englishResource !== null && englishResource !== undefined && englishResource.trim() !== '';
    isArabicResourceHasValue = arabicResource !== "" && arabicResource !== null && arabicResource !== undefined && arabicResource.trim() !== '';

    if (language === 'en' && isEnglishResourceHasValue)
        return englishResource;
    else if (language === 'ar' && isArabicResourceHasValue) 
        return arabicResource;
    else if (isEnglishResourceHasValue) 
        return englishResource;
    else if (isArabicResourceHasValue) 
        return arabicResource;
    else
        return "";
}

export function handleFirstElement(data, tempItem) {
    
    if (data.length > 0) {
        var shouldAddTemp = true;
        for (var i = 0; i < data.length; i++) {
            if (data[i].isTemp
                || data[i].id == undefined
                || data[i].id == null
                || data[i].id == -1) {
                shouldAddTemp = false;
                break;
            }
        }

        if (shouldAddTemp) {
            if (tempItem == undefined || tempItem == null) {
                tempItem = { isTemp: true, name: 'temp' };
            }
            data = [tempItem, ...data];
        } else if (data.length == 1) {
            data = [];
        }
    }
    return data;
}

export function isArabicText(text){
    var arregex = /[\u0600-\u06FF]/;
    return arregex.test(text);
}

export function validateTowDate(startDate,endDate)
{
    var res = new Date(endDate) - new Date(startDate);
    if(res >= 0)
        return true;
    return false;
}

export function isNullOrEmpty(val)
{
    if (val == null || val == undefined || val == "")
        return true;

    return false;
}